module.exports = __webpack_public_path__ + "static/media/img-bronze@2x.a1103b8d.jpg";